// extracted by mini-css-extract-plugin
module.exports = {"sBenefitCard":"sBenefitCard_sBenefitCard__pC3DD"};